import { fspConfig } from "./init/fsp-config"
import tailwindStyles from "./styles/tailwind.css?url"

export function links() {
  const func = "links"

  const { favIcons } = fspConfig

  // TODO: Add Tiffin favicons
  return [
    // radix-ui.css is NOT linked separately — it is @imported into layer(base) by
    // tailwind.css; a second unlayered copy would beat every layer and subvert the
    // cascade-layer ordering set up there.
    { rel: "stylesheet", href: tailwindStyles },
    { rel: "icon", href: favIcons.ico32, sizes: "32x32" },
    { rel: "icon", href: favIcons.svg, type: "image/svg+xml" },
    { rel: "apple-touch-icon", href: favIcons.appleTouch },
  ]
}
